module.exports = __webpack_public_path__ + "img/american-card.96781606.png";